import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default createReducer(initialState, {
  [c.GET_ALERTS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_ALERTS_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.GET_ALERTS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.POST_ALERTS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.POST_ALERTS_SUCCESS]: (state) => ({
    ...state,
    // data: payload,
    isLoading: false
  }),
  [c.POST_ALERTS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  })
});
